import React, { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Paper,
  Typography,
  Collapse,
  Grid,
  Button,
  Autocomplete,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

function FilterSection({
  filters,
  handleChange,
  sectors,
  categories,
  companies,
  handleAutocompleteChange,
  handleSearchSubmit,
}) {
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Alterna a visibilidade dos filtros avançados
  const toggleAdvanced = () => {
    setAdvancedOpen((prev) => !prev);
  };

  // Lida com a mudança no campo de busca única
  const handleInputChange = (event) => {
    const { value } = event.target;
    setSearchTerm(value);

    // Atualiza apenas o filtro global
    handleChange({ target: { name: "search", value } });
  };

  // Lida com o clique no ícone de busca ou a tecla Enter
  const handleSearch = () => {
    handleSearchSubmit();
  };

  // Permite acionar a busca ao pressionar Enter
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // Cria componentes de Autocomplete para os filtros avançados
  const createAutocomplete = (options, label, name) => {
    const value = filters[name]
      ? options.find((option) => option.name === filters[name]) || null
      : null;

    return (
      <Autocomplete
        key={`autocomplete-${name}`}
        options={options}
        getOptionLabel={(option) => option.name}
        value={value}
        onChange={(event, newValue) => handleAutocompleteChange(event, newValue, name)}
        clearOnEscape
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            size="small"
            fullWidth
          />
        )}
      />
    );
  };

  return (
    <Paper elevation={3} sx={{ p: 2, mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        Filtros de Busca
      </Typography>

      {/* Barra de pesquisa única */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: 2,
          mb: 2,
        }}
      >
        <TextField
          label="Buscar Serviços, Setor, Empresa, Categoria"
          variant="outlined"
          size="small"
          fullWidth
          value={searchTerm}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Buscar">
                  <IconButton onClick={handleSearch} edge="end" aria-label="buscar">
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />

        {/* Botão para exibir/ocultar filtros avançados */}
        <Tooltip title="Filtros Avançados">
          <IconButton onClick={toggleAdvanced} aria-label="filtros avançados">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Seção de Filtros Avançados */}
      <Collapse in={advancedOpen}>
        <Box>
          <Typography variant="subtitle1" gutterBottom>
            Filtros Avançados
          </Typography>
          <Grid container spacing={2}>
            {/* Nome do Serviço (filtro individual) */}
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Nome do Serviço"
                name="service_name"
                variant="outlined"
                size="small"
                fullWidth
                value={filters.service_name}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Setor */}
            <Grid item xs={12} sm={6} md={4}>
              {createAutocomplete(sectors, "Setor", "sector_name")}
            </Grid>

            {/* Empresa */}
            <Grid item xs={12} sm={6} md={4}>
              {createAutocomplete(companies, "Empresa", "company_name")}
            </Grid>

            {/* Categoria */}
            <Grid item xs={12} sm={6} md={4}>
              {createAutocomplete(categories, "Categoria", "category")}
            </Grid>

            {/* Preço Máximo */}
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Preço Máximo"
                name="price"
                variant="outlined"
                type="number"
                size="small"
                fullWidth
                value={filters.price}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoneyIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Botão para ocultar filtros avançados */}
            <Grid item xs={12}>
              <Button variant="text" onClick={toggleAdvanced}>
                Ocultar Filtros Avançados
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </Paper>
  );
}

export default FilterSection;
